import * as FilePond from 'filepond';

import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

FilePond.registerPlugin(FilePondPluginFileEncode);
FilePond.registerPlugin(FilePondPluginFileValidateSize);
FilePond.registerPlugin(FilePondPluginFileValidateType);

import de_DE from 'filepond/locale/de-de.js';
import he_HE from 'filepond/locale/he-he.js';

const regex = /^\/he/;

if (window.location.pathname.match(regex)) {
  FilePond.setOptions(he_HE);
} else {
  FilePond.setOptions(de_DE);
}

FilePond.create(
  document.getElementById('fpp'),
   { credits: {},
    acceptedFileTypes:
    ['image/png',
     'image/jpeg',
     'application/pdf',
     'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
     'application/msword'],
    }
);
